import { Component, Vue } from 'vue-property-decorator';
import { AxiosError, AxiosResponse } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import MiFileUpload from '@/components/mi-file-upload/MiFileUpload';
import { addClass, removeClass } from '@/support/Html';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { ProductVariant } from '@/models/ProductVariant';
import { axiosDownload } from '@/support/Client';

@Component<UpdateEanWithCsv>({
  components: {
    MiFileUpload,
    LoaderCard
  },
})
export default class UpdateEanWithCsv extends Vue {
  protected selected: any[] = [];
  protected isLoading: boolean = false;

  protected isUploadingCsv: boolean = false;
  protected selectedCsvFile: File | null = null;
  protected uploadResponse: object | null = null;

  protected acceptedFileTypes = [
    'text/csv',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
  ];
  protected uploadedFile: string = '';

  mounted() {
    const pageHtml = document.querySelectorAll('html')[0];
    addClass(pageHtml, 'overflow-y-hidden');
  }

  protected confirm() {
    this.create();
  }

  protected close() {
    const pageHtml = document.querySelectorAll('html')[0];
    removeClass(pageHtml, 'overflow-y-hidden');
    this.$emit('input', false);
  }

  protected handleItemDropped(file: File) {
    if(!file) {
      return;
    }

    this.selectedCsvFile = file;
    const fileUploadComponent = this.$refs.fileUpload as MiFileUpload;
    fileUploadComponent.uploaded();
  }

  protected create() {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;

    const payload = {
      file: this.selectedCsvFile,
    };

    new ProductVariant()
      .importEans()
      .create(payload)
      .then((response: AxiosResponse) => {
        this.isLoading = false;
        if (response) {
          this.uploadResponse = response;
        }
        this.$emit('success');
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        this.isLoading = false;
      });
  }

  protected async downloadTemplateCsv(): Promise<void> {
    try {
      await axiosDownload(
        {
          url: new ProductVariant().exportEans(),
          accept: 'text/csv; charset=utf-8'
        },
        {}
      );
    } catch (error) {
      ErrorHandler.network(error);
    }
  }
}
